"use strict";

var React = require('react');

module.exports = function () {
  return /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4h-2v1h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-2v1h2a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm-2 6V8.5A1.5 1.5 0 0 0 12.5 7h-6A1.5 1.5 0 0 0 5 8.5V10h1V8.5a.5.5 0 0 1 .5-.5H9v6H8v1h3v-1h-1V8h2.5a.5.5 0 0 1 .5.5V10h1zM2 15V6a1 1 0 0 1 1-1h2V4H3a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h2v-1H3a1 1 0 0 1-1-1z",
    fill: "#2B5672",
    fillRule: "evenodd"
  }));
};